import Moment from 'moment-timezone';
import { AppConstants } from '../shared/Constants';

export const dropDownNormalizer = (data, valueField = 'value') => data && data[valueField];

export const dateOnlyNormalizer = datetime => datetime && Moment(datetime).format(AppConstants.DATE_INPUT_FORMAT);
